import CityPageTemplate from "../city-template/CityPageTemplate";
import { spokaneConfig } from "./data";

export default function SpokanuPage() {
  return <CityPageTemplate config={spokaneConfig} />;
}